const state = () => ({
  selectedCategories: [],
  categories: [],
  categoriesMenu: [],
  childCategories: [],
  childCategoriesMenu: [],
  menuCategory: [],
})

const findCategoryRecursively = (category, categoryId) => {
  if (category.id === categoryId) {
    return true
  }
  category.children.forEach(function (sub) {
    findCategoryRecursively(sub, categoryId)
  })
  return false
}

// const categoriesInterate = (category, selected) => {
//   selected.push(category)
//   category.children.forEach(function (sub) {
//     categoriesInterate(sub, selected)
//   })
// }

const actions = {
  setCategoriesData({ commit, dispatch, state }, categories) {
    if (!Array.isArray(categories)) {
      categories = []
    }

    commit('LOAD_CATEGORIES_DATA', categories)

    const hasMenuCategory =
      !!state.menuCategory && Object.keys(state.menuCategory).length > 0
    const hasCategories = Array.isArray(categories) && categories.length > 0
    if (hasMenuCategory && hasCategories) {
      dispatch('selectCategory', state.menuCategory)
    }
  },

  selectCategory({ commit }, category) {
    commit('SELECT_CATEGORY', category)
  },

  selectCategoryDirect({ commit }, category) {
    commit('SELECT_CATEGORY_DIRECT', category)
  },

  selectCategoryId({ commit, state }, categoryId) {
    let categoryFound = false
    let foundFlag = false

    state.categories.every(function (category) {
      foundFlag = findCategoryRecursively(category, categoryId)
      categoryFound = foundFlag ? category : false
      return !foundFlag
    })

    foundFlag
      ? commit('SELECT_CATEGORY', categoryFound)
      : commit('CLEAR_SELECTED_CATEGORIES')
  },

  unselectCategory({ commit }, categoryId) {
    commit('UNSELECT_CATEGORY', categoryId)
  },

  clearSelectedCategories({ commit }) {
    commit('CLEAR_SELECTED_CATEGORIES')
  },

  setMenuCategory({ commit }, category) {
    commit('SET_MENU_CATEGORY', category)
  },

  clearMenuCategory({ commit }, category) {
    commit('CLEAR_MENU_CATEGORY', category)
  },
}

const mutations = {
  LOAD_CATEGORIES_DATA(state, category) {
    state.categories = []
    state.categories = category
    // Cria uma lista de categorias filhas para facilitar buscas
    state.childCategories = state.categories.flatMap(
      (parent) => parent.children || []
    )
  },

  CLEAR_SELECTED_CATEGORIES(state) {
    state.selectedCategories = []
    state.categories.forEach(function (category) {
      category.selected = false
    })
    state.childCategories.forEach((child) => {
      child.selected = false
    })
  },

  SELECT_CATEGORY_DIRECT(state, category) {
    const exists = state.selectedCategories.some((cat) => cat.id === category.id)
    if (!exists) {
      state.selectedCategories.push(category)
    }
  },

  SELECT_CATEGORY(state, category) {
    const item = state.childCategories.find((cat) => cat.id === category.id)

    if (item) {
      item.selected = !item.selected
      if (item.selected) {
        // Verifica se já existe para não duplicar
        const exists = state.selectedCategories.some(
          (cat) => cat.id === item.id
        )
        if (!exists) {
          state.selectedCategories.push(item)
        }
      } else {
        state.selectedCategories = state.selectedCategories.filter(
          (cat) => cat.id !== category.id
        )
      }
    }
  },

  UNSELECT_CATEGORY(state, categoryId) {
    state.selectedCategories = state.selectedCategories.filter(
      (category) => category.id !== categoryId
    )

    // verifica se está em uma categoria pai e desmarca
    const mainCategory = state.categories.find(
      (category) => category.id === categoryId
    )
    if (mainCategory) {
      mainCategory.selected = false
    }

    // verifica se está em um child e desmarca
    const childCategory = state.childCategories.find(
      (category) => category.id === categoryId
    )
    if (childCategory) {
      childCategory.selected = false
    }
  },

  SET_MENU_CATEGORY(state, category) {
    state.menuCategory = category
  },

  CLEAR_MENU_CATEGORY(state) {
    state.menuCategory = []
  },
}

const getters = {
  getCategories: (state) => {
    return state.categories
  },
  getCategoriesBySearch: (state) => (search) => {
    let searchStr = search.trim().toLowerCase()
    if (searchStr === '') return state.categories
    return state.categories
      .map((category) => {
        const filteredChildren = category.children.filter((child) =>
          child.name.toLowerCase().includes(searchStr)
        )
        if (filteredChildren.length > 0) {
          return {
            ...category,
            children: filteredChildren,
          }
        }
        return null
      })
      .filter(Boolean)
  },
  getSelectedCategoryIds: (state) => {
    let ids = []
    state.selectedCategories.forEach(function (category) {
      ids.push(category.id)
    })
    return ids
  },
  getSelectedCategories: (state) => {
    return state.selectedCategories
  },
  getSelectedState: (state) => (category) => {
    return state.selectedCategories.includes(category)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
